import { breakpoints } from "@brightagency/headstart-common";
import styled from "styled-components";
import { colors } from "../../../utils/colors";

export const Outer = styled.div`
    overflow: hidden;
    background-color: ${colors.brandMid};

    ${breakpoints.large} {
        margin-bottom: -144px;
        padding-bottom: 144px;
    }
`;

export const Inner = styled.div`
    padding: 25px 0;

    ${breakpoints.medium} {
        max-width: 50%;
    }
    ${breakpoints.large} {
        padding: 75px 0;
    }
`;

export const ContentWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    ${breakpoints.medium} {
        flex-direction: row;
    }
`;

export const ImageWrapper = styled.div<{ suburbSelected: boolean }>`
    position: relative;
    height: 100%;
    padding: 40px;
    padding-bottom: 0;
    width: 100%;

    ${breakpoints.large} {
        max-width: 50%;
        margin: 0;
        margin-left: 0;
        display: flex;
        align-items: flex-start;
        justify-content: flex-end;
        padding: 0;
         ${({ suburbSelected }) => (suburbSelected?
            `padding: 0 70px;`
        : '')}
    }

    img{
        width: 100%;
        position: relative;
        z-index: 10;

        ${breakpoints.large} {
            top: 35px;
            z-index: 50;
            min-width: 500px;
        }
    }

    .medium-lower-hidden{
        display: none;
    }
    .medium-lower-visible{
        display: block;
    }
    ${breakpoints.medium} {
        .medium-lower-hidden{
            display: block;
        }
        .medium-lower-visible{
            display: none;
        }
    }
    .image-background{
        background: white;
        height: 100px;
        position: absolute;
        bottom: 0;
        width: 95%;
        margin: 0 auto;
        left: 0;
        right: 0;
        border-radius: 20px 20px 0 0;
        ${breakpoints.medium} {
            height: 150px;
        }
    }
`;

export const PreTitle = styled.p`
    color: ${colors.white};
    line-height: 1;
    margin: 0 0 40px;
    font-weight: 500;
    font-size: 18px;

    strong {
        font-weight: 900;
    }
`;

export const Title = styled.h1`
    margin: 20px 0 40px;
    color: ${colors.white};
    line-height: 1;
    font-size: 46px;
    font-weight: 400;
    position: relative;
    z-index: 1;

    strong {
        font-weight: 900;
    }

    span{
        font-size: 20px;
    }

    ${breakpoints.medium} {
        margin-top: 0;
        font-size: 50px;
    }

    ${breakpoints.large} {
        font-size: 70px;
    }
    
    .larger-font{
        font-size: 46px;
         ${breakpoints.medium} {
            font-size: 60px;
        }
        ${breakpoints.large} {
            font-size: 85px;
        }
    }

    span{
        font-size: inherit;
        position: relative;
        display: inline;
        --underline-width-scale: calc(12 / 8);
        -webkit-box-decoration-break: clone;
        box-decoration-break: clone;
        background-repeat: no-repeat;
        background-image: linear-gradient(180deg, ${colors.brandDark}, ${colors.brandDark});
        background-position-x: calc(4px * var(--underline-width-scale)), 0, 100%;
        background-position-y: calc(85% - -2px * -1);
        background-size: calc(100% - calc(4px * var(--underline-width-scale) * 2)) 35%, auto calc(12 * 1px), auto calc(12 * 1px);
        padding-left: 12px;
        padding-right: 12px;
        left: -8px;
    }
`;

export const SubTitle = styled.h2`
    font-size: 24px;
    color: ${colors.white};
    line-height: 1;
    margin: 0 0 20px;

    ${breakpoints.medium} {
        font-size: 30px;
    }
`;
